import React from "react";
import { useState, useRef, useEffect } from "react";
import { BiSolidVolumeFull, BiSolidVolumeMute } from "react-icons/bi";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
import { cdnImg } from "../../Utils/cdnImage";
import ReactPlayer from "react-player";

const Tv = ({
  loading,
  setLoading,
  detail,
  tvClass,
  mute,
  setMute,
  ref,
  setActiveTab,
}) => {
  const containerRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [needsRotateHack, setNeedsRotateHack] = useState(false);

  const toggleFullscreen = async () => {
    const el = containerRef.current;
    if (!el) return;

    if (!document.fullscreenElement) {
      try {
        if (el.requestFullscreen) {
          await el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
          el.webkitRequestFullscreen();
        }
      } catch (err) {
        console.warn("Fullscreen request failed:", err);
      }

      let lockedSuccessfully = false;
      try {
        if (window.screen.orientation && window.screen.orientation.lock) {
          await window.screen.orientation.lock("landscape");
          lockedSuccessfully = true;
        }
      } catch (err) {
        console.warn("Orientation lock not supported:", err);
      }

      // Native lock failed (common on iOS) → use CSS rotate fallback
      if (!lockedSuccessfully && window.innerHeight > window.innerWidth) {
        setNeedsRotateHack(true);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      try {
        if (window.screen.orientation && window.screen.orientation.unlock) {
          window.screen.orientation.unlock();
        }
      } catch (err) { }
      setNeedsRotateHack(false);
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFs = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
      setIsFullscreen(isFs);
      if (!isFs) setNeedsRotateHack(false);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange,
      );
    };
  }, []);

  // If user physically rotates phone while rotate-hack is active, drop the hack
  useEffect(() => {
    const handleOrientationChange = () => {
      if (window.innerWidth > window.innerHeight) {
        setNeedsRotateHack(false);
      }
    };
    window.addEventListener("resize", handleOrientationChange);
    return () => window.removeEventListener("resize", handleOrientationChange);
  }, []);

  return (
    <div
      data-v-4500b3c2
      className="s-video-contaienr s-relative"
      ref={containerRef}
    >
      <div
        data-v-4500b3c2
        className={`s-video-wrapper s-relative s-z-0 ${tvClass ? "is-outside" : ""
          } ${isFullscreen ? "is-fullscreen" : ""} ${needsRotateHack ? "rotate-hack" : ""
          }`}
      >
        {!tvClass && !loading && (
          <>
            {!mute ? (
              <BiSolidVolumeFull
                onClick={() => setMute(true)}
                size={24}
                color="#c8c7c7"
                className="s-ctrl-icon s-mute-icon"
              />
            ) : (
              <BiSolidVolumeMute
                onClick={() => setMute(false)}
                size={24}
                color="#c8c7c7"
                className="s-ctrl-icon s-mute-icon"
              />
            )}

            {isFullscreen ? (
              <MdFullscreenExit
                onClick={toggleFullscreen}
                size={28}
                color="white"
                className="s-ctrl-icon s-fullscreen-icon"
              />
            ) : (
              <MdFullscreen
                onClick={toggleFullscreen}
                size={28}
                color="white"
                className="s-ctrl-icon s-fullscreen-icon"
              />
            )}
          </>
        )}

        {loading && (
          <div
            style={{
              padding: "0",
              position: "absolute",
              margin: "0",
              width: "100%",
              height: "100%",
            }}
          >
            <img
              src={cdnImg("assets/images/cover-live.webp")}
              alt="Thumbnail"
              style={{
                height: "100%",
                width: "100%",
                overflowX: "hidden",
                overflowY: "hidden",
              }}
            />
          </div>
        )}

        <ReactPlayer
          muted={mute}
          controls={false}
          ref={ref}
          playsinline={true}
          loop={true}
          playing={true}
          id="videoFrame"
          className="s-w-full s-aspect-video s-relative s-z-0"
          onReady={() => setLoading(false)}
          onBuffer={() => setLoading(true)}
          onBufferEnd={() => setLoading(false)}
          width="100%"
          height="100%"
          url={
            detail?.adsStatus
              ? detail?.adsContent
              : `https://aax-eu1314.com/${detail.channel}/index.m3u8`
          }
          config={{
            file: {
              attributes: {
                preload: "none",
                crossOrigin: "true",
              },
              // hlsOptions removed — startLevel was forcing a quality
              // level that likely didn't exist on the test stream
            },
          }}
        />

        <div
          onClick={() => setActiveTab("scoreboard")}
          data-v-4500b3c2
          className="s-btn-close s-w-10 s-h-10 s-absolute s-right-5 s-top-3 s-z-50 s-flex s-justify-center s-items-center s-rounded-full"
          style={!tvClass ? { display: "none" } : {}}
        >
          <span
            data-v-4500b3c2
            className="s-icon-close s-text-16px s-text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default Tv;
